import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Avis } from '../entities/avis.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AvisService {
    readonly BASE: any = PETICIONES.avis;

    constructor(private http: HttpClient) { }

  /**
   * @description
   * Obtiene todos los avis
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un avis por su id
   */
  public findById(id: number): Observable<any> {
    let idavis: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idavis).pipe(delay(DELAY));
  }

  /**
    * @description
    * Obtiene una lista de avis por su dboid
    */
  public findByDboid(dboid: string): Observable<any> {
    let dboidavis: string = (dboid !== undefined && dboid !== null ? dboid + "" : "");
    return this.http.get(this.BASE.findByDboid + "/" + dboidavis).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un avis en la base de datos
   */
  public postAvis(avis: Avis): Observable<any> {
    const json = JSON.stringify(avis);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postAvis, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Se actualiza el atributo AvRead de un avis de 1 a 0
   */
  public postAvRead(avis: Avis): Observable<any> {
    const json = JSON.stringify(avis);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postAvRead, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un avis en la base de datos
   */
  public deleteAvis(avis: Avis): Observable<any> {
    let idavis: string = (avis.id !== undefined && avis.id !== null ? avis.id + "" : "");
    return this.http.get(this.BASE.deleteAvis + "/" + idavis).pipe(delay(DELAY));
  }

}